import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import BackupIcon from '@material-ui/icons/Backup';

import TextField from '../../../Common/UI/TextField';

class PDFInfoForm extends React.Component {
    static propTypes = {
        formData: PropTypes.object.isRequired,
        displayedClientImage: PropTypes.string.isRequired,
        displayedCompanyImage: PropTypes.string.isRequired,
        errorFields: PropTypes.array.isRequired,
        setFormData: PropTypes.func.isRequired,
        setDisplayedImage: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const {
            classes,
            formData,
            setFormData,
            setDisplayedImage,
            displayedCompanyImage,
            displayedClientImage,
            errorFields
        } = this.props;
        return (
            <div className={classes.root}>
                <div className={classes.textFieldContainer}>
                    <TextField 
                        label="Title"
                        error={errorFields.includes('title')}
                        helperText={errorFields.includes('title') ? 'Required' : ''}
                        variant="outlined"
                        fullWidth
                        value={formData.title}
                        onChange={(e) => setFormData('title', e.target.value)}
                    />
                </div>
                <div className={classes.textFieldContainer}>
                    <TextField 
                        label="Project Name"
                        variant="outlined"
                        fullWidth
                        value={formData.subtitle}
                        onChange={(e) => setFormData('subtitle', e.target.value)}
                        error={errorFields.includes('subtitle')}
                        helperText={errorFields.includes('subtitle') && 'Required'}
                    />
                </div>
                <div className={classes.textFieldContainer}>
                    <TextField 
                        label="Author"
                        variant="outlined"
                        fullWidth
                        value={formData.author}
                        onChange={(e) => setFormData('author', e.target.value)}
                        error={errorFields.includes('author')}
                        helperText={errorFields.includes('author') && 'Required'}
                    />
                </div>
                <div className={classes.textFieldContainer}>
                    <TextField 
                        label="Checked"
                        variant="outlined"
                        fullWidth
                        value={formData.check}
                        onChange={(e) => setFormData('check', e.target.value)}
                        error={errorFields.includes('check')}
                        helperText={errorFields.includes('check') && 'Required'}
                    />
                </div>
                <div className={classes.textFieldContainer}>
                    <TextField 
                        label="Reference"
                        tooltip="Enter a document number, postcode, or other unique identifier"
                        variant="outlined"
                        fullWidth
                        placeholder="Optional"
                        value={formData.reference}
                        onChange={(e) => setFormData('reference', e.target.value)}
                    />
                </div>
                <Typography
                    variant="subtitle2"
                    className={classes.companyLogoTitle}
                >
                    Client Logo
                </Typography>
                <div className={classes.imageUploadRow}>
                    <input
                        accept="image/*"
                        className={classes.input}
                        id="client-upload-logo"
                        type="file"
                        onChange={(e) => setDisplayedImage(e, 'displayedClientImage')}
                    />
                    <label htmlFor="client-upload-logo">
                        { !displayedClientImage ? (
                            <span className={classes.uploadImageButton}>
                                <div className={classes.uploadImageButtonRow}>
                                    <BackupIcon />
                                    <Typography
                                        variant="subtitle2"
                                    >
                                        Upload your logo here
                                    </Typography>
                                </div>
                            </span>
                        ) : (
                            <div className={classes.imageUploadPreview} style={{ backgroundImage: `url('${displayedClientImage}')` }}></div>
                        )}
                    </label>
                </div>
                <Typography
                    variant="subtitle2"
                    className={classes.companyLogoTitle}
                >
                    Company Logo
                </Typography>
                <div className={classes.imageUploadRow}>
                    <input
                        accept="image/*"
                        className={classes.input}
                        id="company-upload-logo"
                        type="file"
                        onChange={(e) => setDisplayedImage(e, 'displayedCompanyImage')}
                    />
                    <label htmlFor="company-upload-logo">
                        { !displayedCompanyImage ? (
                            <span className={classes.uploadImageButton}>
                                <div className={classes.uploadImageButtonRow}>
                                    <BackupIcon />
                                    <Typography
                                        variant="subtitle2"
                                    >
                                        Upload your logo here
                                    </Typography>
                                </div>
                            </span>
                        ) : (
                            <div className={classes.imageUploadPreview} style={{ backgroundImage: `url('${displayedCompanyImage}')` }}></div>
                        )}
                    </label>
                </div>

            </div>
        );
    }
}

const styles = (theme) => ({
    root: {
        padding: '0 20px'
    },
    textFieldContainer: {
        paddingTop: '20px'
    },
    companyLogoTitle: {
        color: theme.palette.primary.contrastText,
        paddingTop: '20px',
        fontSize: '14px'
    },
    imageUploadRow: {
        paddingTop: '10px',
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    imageUploadPreview: {
        width: '100%',
        minHeight: '80px',
        maxHeight: '100px',
        marginBottom: '10px',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        backgroundColor: '#DEDEDE',
        borderRadius: '4px',
        cursor: 'pointer'
    },
    uploadImageButton: {
        height: '80px',
        border: `1px dashed ${theme.palette.grey.variant2}`,
        borderRadius: '6px',
        display: 'grid',
        placeItems: 'center',
        color: theme.palette.primary.contrastText,
        width: '100%',
        backgroundColor: 'transparent',
        cursor: 'pointer',
        '&:hover': {
            backgroundColor: 'rgb(0, 0, 0, 0.1)'
        }
    },
    uploadImageButtonRow: {
        display: 'flex',
        columnGap: '10px',
        alignItems: 'center'
    },
    input: {
        display: 'none'
    }
});

export default withStyles(styles)(PDFInfoForm);